<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <Teleport to="body">
    <transition
      enter-active-class=""
      enter-from-class="modal-opacity-0"
      enter-to-class="modal-opacity-100"
      leave-active-class=""
      leave-from-class="modal-opacity-100"
      leave-to-class="modal-opacity-0"
    > 
      <div
        v-show="showModal"
        class="modal"
        :class="{ 'modal--side-modal': isSideModal }"
      >
          <transition
            enter-active-class="slide-left-enter-active"
            enter-from-class="slide-left-enter"
            enter-to-class=""
            leave-active-class="slide-left-enter-active"
            leave-from-class=".slide-left-leave-to"
            leave-to-class="slide-left-leave-to"
          >

              <div
                v-show="showModal"
                ref="modal"
                role="dialog"
                aria-modal="true"
              >
                <slot></slot>
              </div>
          </transition>
          </div>
      </transition>
  </Teleport>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import useClickOutside from '../../hooks/useClickOutside';
import windowScrollLockHandler from '../../hooks/scrollLock';
import useFocusTrap from '../../hooks/useFocusTrap';

const { clearFocusTrap } = useFocusTrap();


const showModal = ref(props.show);
const modal = ref(null);

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  isSideModal: {
    type: Boolean,
    default: false
  }
});


const { onClickOutside } = useClickOutside();
const emit = defineEmits(['close:modal']);
const modalOpener = ref(null);

function closeModal() {
  clearFocusTrap();
  emit('close:modal', false);
}

onClickOutside(modal, () => {
  if (showModal.value === true) {
    closeModal();
  }
});

watch(
  () => props.show,
  show => {
    showModal.value = show;

    if(showModal.value) {
      windowScrollLockHandler(true)
      modalOpener.value = document.activeElement;
    } else {
      windowScrollLockHandler(false)
      setTimeout(() => {
        modalOpener.value.focus();
      }, 300)
    }

    setSideModalPosition();
  },
);

function handleCloseModal(e) {
  if (e.key === "Escape") {
    closeModal();
  }
}

function setSideModalPosition() {
  if(props.isSideModal) {
    const sideModal = document.querySelector('.modal--side-modal');
    const headerBottom = document.querySelector('.header')?.getBoundingClientRect().bottom;
    sideModal.style.top = headerBottom + 'px';
    sideModal.style.height = `calc(100% - ${headerBottom || 0}px)`;
  }
}

onMounted(() => {
  document.addEventListener('keyup', handleCloseModal);
})
</script>
